// ie
const $ieHeader = $('.InternetExplorer header');
const $ieMain = $('.InternetExplorer main');

// set padding to adjust for `position: fixed` header
const headerHeight = $($ieHeader).height();
$($ieMain).css('padding-top', headerHeight + 'px');

$('.InternetExplorer header .alert').on('closed.bs.alert', function () {
  const headerHeight = $($ieHeader).height();
  $($ieMain).css('padding-top', 0);
  $($ieMain).css('padding-top', headerHeight + 'px');
});
